var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparklingWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18.5V5.5C19 4.87518 18.6799 4.5 18.1799 4C17.7964 3.60084 17.6429 3.42145 17.5404 3.18213C17.4704 3.01874 17.4155 2.81411 17.3664 2.49068C17.7242 2.43384 17.9978 2.12387 17.9978 1.75C17.9978 1.33579 17.662 1 17.2478 1H6.7478C6.33359 1 5.9978 1.33579 5.9978 1.75C5.9978 2.12516 6.27326 2.43599 6.63296 2.49126C6.58397 2.81277 6.52918 3.01717 6.45931 3.18069C6.35664 3.421 6.20286 3.6015 5.82009 4C5.32 4.5 5 4.87519 5 5.5V18.5C5 18.7 5.03 18.89 5.09 19.06L6.03 22.45C6.11953 22.79 6.43 23.0022 6.76639 23H17.2319C17.567 23 17.8774 22.7883 17.9711 22.4506L18.9121 19.0607C18.969 18.8907 19 18.7035 19 18.5ZM6.75 5.25C6.61193 5.25 6.5 5.36193 6.5 5.5V18.5C6.5 18.6381 6.61193 18.75 6.75 18.75H17.25C17.3881 18.75 17.5 18.6381 17.5 18.5V5.5C17.5 5.36193 17.3881 5.25 17.25 5.25H6.75ZM15.8528 2.5H8.14664C8.08304 2.99218 7.9968 3.39259 7.84716 3.75H16.1519C16.0024 3.39282 15.9163 2.99248 15.8528 2.5ZM7.32041 21.5H16.6783L17.0253 20.25H6.97398L7.32041 21.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6699 8C11.6699 8.55228 11.2222 9 10.6699 9C10.1176 9 9.66992 8.55228 9.66992 8C9.66992 7.44772 10.1176 7 10.6699 7C11.2222 7 11.6699 7.44772 11.6699 8Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6699 12.75C9.97957 12.75 9.41992 13.3096 9.41992 14C9.41992 14.6904 9.97957 15.25 10.6699 15.25C11.3603 15.25 11.9199 14.6904 11.9199 14C11.9199 13.3096 11.3603 12.75 10.6699 12.75ZM7.91992 14C7.91992 12.4812 9.15114 11.25 10.6699 11.25C12.1887 11.25 13.4199 12.4812 13.4199 14C13.4199 15.5188 12.1887 16.75 10.6699 16.75C9.15114 16.75 7.91992 15.5188 7.91992 14Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9199 10C12.9199 9.0335 13.7034 8.25 14.6699 8.25C15.6364 8.25 16.4199 9.0335 16.4199 10C16.4199 10.9665 15.6364 11.75 14.6699 11.75C13.7034 11.75 12.9199 10.9665 12.9199 10Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklingWater);
export default __webpack_public_path__ + "static/media/SparklingWater.e197af924f336d6d725d8604134f331a.svg";
export { ForwardRef as ReactComponent };